import changePassFormSubmitted from "../events/change-pass-form-submitted.js";
function makeEventRouter() {
    const router = {
        'change-pass-form-submitted': changePassFormSubmitted
    };
    return Object.freeze({
        get
    });
    function get(action) {
        return router[action];
    }
}
;
const APP_VIEWS = makeEventRouter();
export default APP_VIEWS;
